import SectionContainer from "../../ui/SectionContainer";
import HighlightBand from "../../ui/HighlightBand";

import { Description } from "./styles";

import PartnerLogo from "../../../assets/images/branding/logo-caioba-real-madrid.webp";
import BackgroundImage from "../../../assets/images/sections/real-madrid/background.jpg";

const RealMadrid = () => {
  return (
    <SectionContainer
      backgroundImage={BackgroundImage}
      id="realmadrid"
      flexDirection=""
      padding="100px 20px"
    >
      <img alt="logo" src={PartnerLogo} />

      <Description>
        <HighlightBand>
          <h1>UMA PARCERIA QUE TRANSFORMA.</h1>
        </HighlightBand>
        <p>
          A ESP tem orgulho de caminhar lado a lado com a{" "}
          <strong>Fundação Real Madrid</strong>, uma união que não só chama
          atenção, mas que{" "}
          <strong>faz a diferença na formação dos nossos alunos.</strong>
        </p>
        <p>
          De um lado, a metodologia da ESP, criada por{" "}
          <strong>Caio Ribeiro</strong> e <strong>Denilson Show</strong>, cheia
          de prática, vivência e propósito.
        </p>
        <p>
          Do outro, a Fundação Real Madrid, referência mundial no
          desenvolvimento técnico e tático de jovens atletas. Juntas, essas duas
          forças unem experiências e valores para oferecer{" "}
          <strong>um ensino mais completo, humano e transformador</strong>,
          dentro e fora das quatro linhas. Mais do que futebol: uma verdadeira
          escola para a vida.
        </p>
      </Description>
    </SectionContainer>
  );
};

export default RealMadrid;
